import { useLanguage } from "@context/use-language";
import { Button } from "@dm-4dev/ui";
import { trackError } from "@mod/core/config/initialize-analytics";
import { PostHogProvider } from "posthog-js/react";
import { useEffect } from "react";
import { useRouteError } from "react-router-dom";

const {
  POSTHOG_KEY,
  POSTHOG_HOST
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
} = dmenv;

export const ErrorPage = () => {
  const { t } = useLanguage();
  const error = useRouteError() as any;

  const refreshPage = () => {
    // relaoad page
    window.location.reload();
  };

  useEffect(() => {
    trackError(error?.message ?? "Unknown error", true);
  }, []);

  return (
    <PostHogProvider
      apiKey={POSTHOG_KEY}
      options={{
        api_host: POSTHOG_HOST
      }}
    >
      <div className="flex flex-col items-center justify-center h-screen">
        <h3 className="text-4xl font-bold mb-4">{t("oops")}</h3>
        <p className="text-lg text-gray-600">{t("genericErrorTitle")}</p>
        <Button onClick={refreshPage}>{t("reload")}</Button>
      </div>
    </PostHogProvider>
  );
};
